import axios from "axios";
import Config from "src/config";

const v2_actionToggleBotSilence = (chatId, data) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat/${chatId}/silenciar-bot`,
        data
    });
};
export default v2_actionToggleBotSilence;
